import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { supported } from '@mapbox/mapbox-gl-supported';

import { bugsnagClient } from '../bugsnagUtils';
import { deeplinkUrl } from '../deeplinkUtils';
import ExternalLink from './ExternalLink';
import Prompt from './Prompt';
import Svg from './Svg';
import MapboxGlNotSupportedError from '../errors/MapboxGlNotSupportedError';

const IS_MAPBOX_GL_SUPPORTED = supported();

const helpLinks = [
  'https://www.mapbox.com/help/mapbox-browser-support/#mapbox-gl-js',
  'https://get.webgl.org',
];

const MapboxGlSupportBoundry = ({ children }) => {
  useEffect(() => {
    if (!IS_MAPBOX_GL_SUPPORTED) {
      bugsnagClient.notify(new MapboxGlNotSupportedError());
    }
  }, []);

  if (IS_MAPBOX_GL_SUPPORTED) {
    return children;
  }

  return (
    <Prompt>
      <h1>{__('Uh-oh, something went wrong!')}</h1>
      <p>{__('It seems that Mapbox GL, which is required to run the map widget, is not supported in your browser. It could be that WebGL is disabled in your browser.')}</p>
      <h3>{__('Follow the links below for troubleshooting')}</h3>
      <ul>
        {helpLinks.map((helpLink) => (
          <li key={helpLink}>
            <ExternalLink href={helpLink}>{helpLink}</ExternalLink>
          </li>
        ))}
      </ul>
      <hr />
      <div className="cta-wrapper">
        <p>
          <ExternalLink href={deeplinkUrl('mapbox-gl-support-boundry')}>
            {__('Download the Fishbrain app')}
            <Svg className="cta-logo" icon="logo" />
          </ExternalLink>
        </p>
      </div>
      <p><small>{__('Available for iOS and Android')}</small></p>
    </Prompt>
  );
};

MapboxGlSupportBoundry.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MapboxGlSupportBoundry;
